var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('title-bar',{attrs:{"title":_vm.$lang.privacy_title}}),_c('div',{staticClass:"content-c",domProps:{"innerHTML":_vm._s(_vm.$lang.privacy_txt)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }